import { Component } from '@angular/core';
import * as moment from 'moment';
import { InformesService } from 'app/cartera-vencida/services/informes.service';
import { Group, Bill } from './dobles.entities';

@Component({
    templateUrl:'dobles.component.html',
    styleUrls:['dobles.component.scss'],
    selector:'app-dobles'

})

export class DoblesComponent{
    constructor(private _informes:InformesService){
        this.empresa = 1;
        this.pagina = 1;
        this.fechaInicial = moment().subtract(2,'months');
        this.fechaFin = moment();
    }
    public fechaInicial:any;
    public fechaFin:any;
    public groups:Array<Group>;
    public informe:string;
    public pagina:number;
    public empresa:number;
    /** 
     * @method searchReport metodo para buscar los grupos con sus respectivas facturas
     */
    searchReport(){
        this.pagina = 1;
        const fechaI = moment(this.fechaInicial).format("YYYY-MM-DD");
        const fechaF = moment(this.fechaFin).format("YYYY-MM-DD");
        this._informes.reporteCarteraIndividual(this.empresa,fechaI,fechaF).subscribe(groups=>{
            this.groups = groups;
        });
    }

    diasDeFactura(data:string):number{

        return 1;
    }

    totales(){

    }

    sumaFacturas(bills:Array<Bill>){
        let sum = {};

        for(let factura of bills){
            for(let key in factura){
                if(sum[key] === undefined){
                    sum[key]= 0;
                }
                sum[key] += factura[key];
            }
        }

        
    }
}